import { Box, Card, CircularProgress, IconButton, Stack, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import TrackChangesSharpIcon from "@mui/icons-material/TrackChangesSharp";

const ActiveUser = () => {
  const { data: publisherRevenue, loading } = useSelector(
    (state) => state.publisherRevenueDetails
  );
  return (
    <>
      <Card sx={{ p: 2, color: "#0C6A96" }}>
        <Stack direction="row" justifyContent="space-between">
          <TrackChangesSharpIcon color="#0C6A96" />
          <Typography
            sx={{
              color: "#5E6C8A",
              fontFamily: "Montserrat,sans-serif",
              fontStyle: "normal",
            }}
            variant="subtitle2"
          >
           Today Active User
          </Typography>
          {/* <IconButton sx={{ color: '#5E6C8A' }} ><CachedIcon /></IconButton> */}
        </Stack>

        {loading ? (
          <CircularProgress />
        ) : (
          <Box>
            <Typography
              variant="h3"
              color="primary"
              sx={{ fontWeight: 600, color: "#071D45" }}
            >
              {publisherRevenue?.activeUser
                ? publisherRevenue?.activeUser
                : "---"}
            </Typography>
          </Box>
        )}
      </Card>
    </>
  );
};

export default ActiveUser;
